import { render } from "./Exchange.vue?vue&type=template&id=f515bcc4&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=f515bcc4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f515bcc4"]])

export default __exports__